<img src="../../../assets/preloader.gif" alt="" srcset="" style="height: 125px;margin-top: 40vh;margin-left:45vw;">